import { Injectable        } from '@angular/core';
import { NotifierManager   } from '../managers/notifier/notifier.manager';
import { Notifier          } from '../enums/notifier/notifier.enum';
import { NotifierMessage   } from '../enums/notifier/message/notifier.enum';

@Injectable
({
  providedIn: 'root'
})

export class StatisticsError 
{
    constructor(private _notifier : NotifierManager) {}

    unauthUser() 
    {
      this._notifier.show( Notifier.ERROR, NotifierMessage.STATISTIC_UNAUTH_USER)
    }

    unauthUserResource() 
    {
        this._notifier.show( Notifier.ERROR, NotifierMessage.STATISTIC_UNAUTH_USER_RESOURCE)
    }

    invalidDateFormat() 
    {
        this._notifier.show( Notifier.ERROR, NotifierMessage.STATISTIC_WRONG_DATE_FORMAT)
    }

    invalidDateTo() 
    {
        this._notifier.show( Notifier.ERROR, NotifierMessage.STATISTIC_INVALID_DATE_TO)
    }

    invalidServiceCounter()
    {
        this._notifier.show( Notifier.ERROR, NotifierMessage.STATISTIC_INVALID_SC)
    }

    invalidDetailTotal()
    {
        this._notifier.show( Notifier.ERROR, NotifierMessage.STATISTIC_INVALID_DT)
    }

    invalidPeriod()
    {
        this._notifier.show( Notifier.ERROR, NotifierMessage.STATISTIC_INVALID_PERIOD)
    }

    specifyJustOrgOrSite()
    {
        this._notifier.show( Notifier.ERROR, NotifierMessage.STATISTIC_SPECIFY_JUST_SITE_OR_ORG)
    }
}